import { FC, useEffect, useMemo, useState } from "react";
import {
  FIELD_OCCURENCES_SUMMARY,
  PAGE_SIZE_OPTIONS,
} from "../../utils/constants";
import SearchTable from "../../components/template/Search/SearchTable";
import { TableConfig } from "../../types/Components/Table/TableConfig";
import { useFilter } from "../../hooks/filter/useFilter";
import { useForm } from "react-hook-form";
import { FilterConfig } from "../../types/Components/Table/FilterConfig";
import { Option } from "../../types/General/Option";
import useFetchData from "../../hooks/data/useFetchData";
import { getProvince } from "../../services/TabelasAuxiliares/getProvince";
import { getCountyById } from "../../services/TabelasAuxiliares/getCountyById";
import { updateSelectedFilterItemsName } from "../../helpers/updateSelectedFilterItemsName";
import { getFiltersArray } from "../../helpers/getFiltersArray";
import { getFieldOccurences } from "../../services/FieldOccurences/getFieldOccurences";
import { fieldOccurencesTableSelectFilterData } from "./data/fieldOccurencesTableSelectFilterData";
import TableFieldOccurrences from "./TableFieldOccurrences";
import { useCustomModal } from "../../hooks/modal/useCustomModal";
import TableIndicatorHistory from "../Indicator/TableIndicatorHistory";
import { getFieldOccurencesLevels } from "../../services/FieldOccurences/getFieldOccurencesLevels";
import { getFieldOccurencesTypes } from "../../services/FieldOccurences/getFieldOccurencesTypes";
import { useLocation, useNavigate } from "react-router-dom";
import ModalFieldOccurrences from "./component/ModalFieldOccurrences";
import { PaginationConfig } from "../../types/Components/Table/PaginationConfig";
import useTableRendering from "../../hooks/table/useTableRendering";
import { PaginationValues } from "../../types/General/PaginationValues";
import { ModalConfig } from "../../types/Components/Modal/ModalConfig";
import { Dayjs } from "dayjs";
import { useAuth } from "../../provider/AuthProvider";
import { IndicatorHistory } from "../../types/Indicator/IndicatorDataReport/IndicatorHistory";
import { getIndicatorRegionHistory } from "../../services/Indicator/getIndicatorRegionHistory";
import { applyRoleBasedFilters } from "../../helpers/Filter/authUserFilter";
import TabComponent from "../../components/molecule/Tab/TabComponent";
import { Button, Flex, Heading, Text } from "@chakra-ui/react";
import OccurrenceAlertSan from "./AlertSan/OccurrenceAlertSan";
import { getOccurrenceAlertSan } from "../../services/FieldOccurences/getOccurrenceAlertSan";
import { useOccurrenceAlertSan } from "./hooks/useOccurrenceAlertSan";

interface FilterState {
  TypeId: Option | null;
  LevelId: Option | null;
  Origin: Option | null;
  CreatedAtStart: Dayjs | null;
  CreatedAtEnd: Dayjs | null;
  IsActive: Option | null;
  ProvinceId: Option | null;
  CountyId: Option | null;
}

interface OptionsState {
  typeOptions: Option[];
  levelOptions: Option[];
  originOptions: Option[];
  createdAtStartOptions: Dayjs[];
  createdAtEndOptions: Dayjs[];
  stateOptions: Option[];
  provinceOptions: Option[];
  countyOptions: Option[];
}

const FieldOccurrences: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { auth } = useAuth();
  const user = auth.user;
  const [isLoaded, setIsLoaded] = useState(false);
  const [errorFindingData, setErrorFindingData] = useState(false);
  const [dataTable, setDataTable] = useState<any[]>([]);
  const [historyData, setHistoryData] = useState<IndicatorHistory[]>([]);
  const [isHistoryLoaded, setIsHistoryLoaded] = useState<boolean>(true);
  const [historyTotalItems, setHistoryTotalItems] = useState<number>(0);
  const [selectedFilterItems, setSelectedFilterItems] = useState<string>("");
  const [pageSize, setPageSize] = useState(PAGE_SIZE_OPTIONS[0]);
  const [historyPageSize, setHistoryPageSize] = useState(PAGE_SIZE_OPTIONS[0]);
  const [, setIsHistorySearching] = useState<boolean>(true);
  const [, setErrorFindingHistoryData] = useState(false);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [isSearching, setIsSearching] = useState<boolean>(true);
  const [, setIdItem] = useState<number>(0);
  const [occurrenceAlertSanTotalItems, setOccurrenceAlertSanTotalItems] =
    useState<number>(0);
  const [occurrenceAlertSanDataTable, setOccurrenceAlertSanDataTable] =
    useState<any[]>([]);
  const [
    originalOccurrenceAlertSanDataTable,
    setOriginalOccurrenceAlertSanDataTable,
  ] = useState<any[]>([]);
  const [isLoadedOccurrenceAlertSan, setIsLoadedOccurrenceAlertSan] =
    useState<boolean>(false);
  const [occurrenceAlertSanPageSize, setOccurrenceAlertSanPageSize] =
    useState<number>(PAGE_SIZE_OPTIONS[0]);
  const receivedFilters = location.state?.filters;

  const {
    controlOccurrenceAlertSan,
    paginationConfigOccurrenceAlertSan,
    modalConfigOccurrenceAlertSan,
    tableConfigOccurrenceAlertSan,
    occurrenceAlertSanCurrentPage,
    filterConfigOccurrenceAlertSan,
    occurrenceAlertSanFilters,
    setOccurrenceAlertSanFilter,
    resetOccurrenceAlertSan,
    setOccurrenceAlertSanCreatedAtStart,
    setOccurrenceAlertSanCreatedAtEnd,
  } = useOccurrenceAlertSan({
    user,
    receivedFilters,
    setIsSearching,
    occurrenceAlertSanDataTable,
    originalOccurrenceAlertSanDataTable,
    setOccurrenceAlertSanDataTable,
    isLoadedOccurrenceAlertSan,
    occurrenceAlertSanPageSize,
    setOccurrenceAlertSanPageSize,
    occurrenceAlertSanTotalItems,
  });

  const [filterState, setFilterState] = useState<FilterState>({
    TypeId: null,
    LevelId: null,
    Origin: null,
    CreatedAtStart: null,
    CreatedAtEnd: null,
    IsActive: null,
    ProvinceId:
      receivedFilters?.province ??
      (user?.role?.level?.id >= 4 && user?.province
        ? { id: user.province.id, name: user.province.name }
        : null),
    CountyId:
      receivedFilters?.county ??
      (user?.role?.level?.id === 5 && user?.county
        ? { id: user.county.id, name: user?.county.name }
        : null),
  });
  const [optionsState, setOptionsState] = useState<OptionsState>({
    typeOptions: [] as Option[],
    levelOptions: [] as Option[],
    originOptions: [
      { id: "Sistema", name: "Sistema" },
      { id: "Manual", name: "Manual" },
    ],
    createdAtStartOptions: [] as Dayjs[],
    createdAtEndOptions: [] as Dayjs[],
    stateOptions: [
      { id: "true", name: "A decorrer" },
      { id: "false", name: "Terminado" },
    ],
    provinceOptions: [] as Option[],
    countyOptions: [] as Option[],
  });
  const { control, setValue } = useForm();
  const filterNames = useMemo(
    () => [
      "TypeId",
      "IsActive",
      "Origin",
      "CreatedAtStart",
      "CreatedAtEnd",
      "StateId",
      "ProvinceId",
      "CountyId",
      "Title",
    ],
    [],
  );
  const [countyLoaded, setCountyLoaded] = useState<boolean>(false);
  const { filters, setFilter } = useFilter({ setValue, filterNames });
  useEffect(() => {
    const fetchData = (
      filterValues?: any,
      paginationValues?: PaginationValues,
      occurrenceAlertSanFilterValues?: any,
      paginationValuesOccurrenceAlertSan?: PaginationValues,
    ) => {
      setErrorFindingData(false);
      setIsLoaded(false);
      setIsLoadedOccurrenceAlertSan(false);
      const updatedFilters = applyRoleBasedFilters(
        user,
        filterValues,
        setFilter,
        false,
        receivedFilters,
      );
      const updatedOccurrenceAlertSanFilters = applyRoleBasedFilters(
        user,
        occurrenceAlertSanFilterValues,
        setOccurrenceAlertSanFilter,
        false,
        receivedFilters,
      );
      setTimeout(() => {
        getFieldOccurences(undefined, updatedFilters, paginationValues)
          .then((result) => {
            setDataTable(result.content);
            setTotalItems(result.totalItems);
            setIsLoaded(true);
            setIsSearching(false);
          })
          .catch((error) => {
            console.log("API Error:", error);
            setErrorFindingData(true);
            setIsSearching(false);
          });
        getOccurrenceAlertSan(
          undefined,
          updatedOccurrenceAlertSanFilters,
          paginationValuesOccurrenceAlertSan,
        )
          .then((result) => {
            setOccurrenceAlertSanDataTable(result.content);
            setOriginalOccurrenceAlertSanDataTable(result.content);
            setOccurrenceAlertSanTotalItems(result.totalItems);
            setIsLoadedOccurrenceAlertSan(true);
            setIsSearching(false);
          })
          .catch((error) => {
            console.log("API Error:", error);
            setErrorFindingData(true);
            setIsSearching(false);
          });
      }, 1000);
    };
    isSearching &&
      fetchData(
        filters,
        {
          CurrentPage: currentPage,
          PageSize: pageSize,
        },
        occurrenceAlertSanFilters,
        {
          CurrentPage: occurrenceAlertSanCurrentPage,
          PageSize: occurrenceAlertSanPageSize,
        },
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearching]);

  useEffect(() => {
    const fetchData = (paginationValues?: PaginationValues) => {
      setErrorFindingHistoryData(false);
      setIsHistoryLoaded(false);
      const params = {
        IndicatorId: control._formValues.row?.indicator?.id,
        FrequencyId: control._formValues.row?.indicator?.frequency?.id,
        ProvinceId: control._formValues.row?.province?.id ?? "",
        CountyId: control._formValues.row?.county?.id ?? "",
      };
      getIndicatorRegionHistory(params, undefined, paginationValues)
        .then((result) => {
          setHistoryData(result.content);
          setIsHistoryLoaded(true);
          setIsHistorySearching(false);
          setHistoryTotalItems(result.totalItems);
        })
        .catch((error) => {
          console.log("API Error:", error);
          setErrorFindingHistoryData(true);
          setIsHistorySearching(false);
        });
    };
    control._formValues.row?.indicator?.id &&
      control._formValues.row?.province?.id &&
      fetchData({
        CurrentPage: historyCurrentPage,
        PageSize: historyPageSize,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    control._formValues.row?.indicator?.id,
    control._formValues.row?.province?.id,
  ]);

  const { isLoaded: provinceLoaded } = useFetchData(getProvince, (data) =>
    setOptionsState((prev) => ({ ...prev, provinceOptions: data })),
  );

  const { isLoaded: levelLoaded } = useFetchData(
    getFieldOccurencesLevels,
    (data) => setOptionsState((prev) => ({ ...prev, levelOptions: data })),
  );

  const { isLoaded: typeLoaded } = useFetchData(
    getFieldOccurencesTypes,
    (data) => setOptionsState((prev) => ({ ...prev, typeOptions: data })),
  );

  useEffect(() => {
    const updateCountyOptions = () => {
      setCountyLoaded(false);
      if (filterState.ProvinceId) {
        getCountyById({ ParentId: filterState.ProvinceId.id })
          .then((result) => {
            setOptionsState((prev) => ({
              ...prev,
              countyOptions: result,
            }));
          })
          .finally(() => {
            setCountyLoaded(true);
          });
      } else {
        setCountyLoaded(true);
        setOptionsState((prev) => ({ ...prev, countyOptions: [] }));
      }
    };
    updateCountyOptions();
  }, [filterState.ProvinceId]);

  useEffect(() => {
    const displayFormats = {
      CreatedAtStart: "DD/MM/YYYY",
      CreatedAtEnd: "DD/MM/YYYY",
    };
    updateSelectedFilterItemsName(
      filterState,
      filters,
      setSelectedFilterItems,
      filterNames,
      displayFormats,
    );
  }, [filters, filterState, filterNames]);

  const filtersArray = getFiltersArray(filterNames, filters, setFilter);

  const filterChildren = fieldOccurencesTableSelectFilterData(
    optionsState.typeOptions,
    optionsState.levelOptions,
    optionsState.originOptions,
    optionsState.stateOptions,
    optionsState.provinceOptions,
    optionsState.countyOptions,
    control,
    setFilter,
    (CreatedAtStart: any) =>
      setFilterState((prev) => ({ ...prev, CreatedAtStart })),
    (CreatedAtEnd: any) =>
      setFilterState((prev) => ({ ...prev, CreatedAtEnd })),
    (TypeId: any) => setFilterState((prev) => ({ ...prev, TypeId })),
    (LevelId: any) => setFilterState((prev) => ({ ...prev, LevelId })),
    (Origin: any) => setFilterState((prev) => ({ ...prev, Origin })),
    (IsActive: any) => setFilterState((prev) => ({ ...prev, IsActive })),
    (ProvinceId: any) => setFilterState((prev) => ({ ...prev, ProvinceId })),
    (CountyId: any) => setFilterState((prev) => ({ ...prev, CountyId })),
    filterState.ProvinceId,
    filterState.CreatedAtStart,
    filterState.CreatedAtEnd,
    provinceLoaded,
    countyLoaded,
    typeLoaded,
    levelLoaded,
    user,
    receivedFilters,
  );

  const { isOpen, title, buttonTitle, openModal, closeModal } = useCustomModal(
    "",
    "",
  );

  const tableConfig: TableConfig = {
    tableName: "Lista de Ocorrências",
    dataTable,
    setDataTable,
    renderTable: (dataTable) => (
      <TableFieldOccurrences
        dataTable={dataTable}
        isLoaded={isLoaded}
        setValue={setValue}
        openModal={openModal}
      />
    ),
    isLoaded,
    errorFindingData,
    searchTitle: "Pesquisar pelo Título da ocorrência",
  };

  const filterConfig: FilterConfig = {
    filterChildren,
    filters: filtersArray,
    selectedFilterItem: selectedFilterItems,
  };

  const modalTableConfig: TableConfig = {
    tableName: `Histórico do indicador (Província ${
      control._formValues.row?.province?.name ?? ""
    })`,
    dataTable: historyData,
    setDataTable: setHistoryData,
    renderTable: (historyData) => (
      <TableIndicatorHistory
        dataTable={historyData}
        isLoaded={isHistoryLoaded}
        frequencyId={control._formValues.row?.indicator?.frequency?.id}
      />
    ),
    isLoaded,
  };

  const handleAddNewItem = () => {
    navigate("/ocorrencias-no-terreno/criar-ocorrencias-no-terreno");
  };

  const { currentPage, totalPages, handlePageChange, renderContent } =
    useTableRendering(tableConfig, pageSize, totalItems, setIsSearching);

  const {
    currentPage: historyCurrentPage,
    totalPages: historyTotalPages,
    handlePageChange: handleHistoryPageChange,
    renderContent: historyRenderContent,
  } = useTableRendering(
    modalTableConfig,
    historyPageSize,
    historyTotalItems,
    setIsHistorySearching,
  );

  const paginationConfig: PaginationConfig = {
    pageSize,
    currentPage,
    totalPages,
    handlePageChange,
    renderContent,
    setPageSize,
    totalItems,
  };

  const historyPaginationConfig: PaginationConfig = {
    pageSize: historyPageSize,
    currentPage: historyCurrentPage,
    totalPages: historyTotalPages,
    handlePageChange: handleHistoryPageChange,
    renderContent: historyRenderContent,
    setPageSize: setHistoryPageSize,
    totalItems: historyTotalItems,
  };

  const modalConfig: ModalConfig = {
    isOpen,
    title,
    buttonTitle,
    openModal,
    closeModal,
  };

  const tabs = ["Ocorrências no Terreno"];
  const panels = [
    <SearchTable
      showModal
      searchTableName=""
      tableConfig={tableConfig}
      filterConfig={filterConfig}
      paginationConfig={paginationConfig}
      setIsSearching={setIsSearching}
      setDates={[
        (CreatedAtStart: Dayjs | null) =>
          setFilterState((prev) => ({
            ...prev,
            CreatedAtStart: CreatedAtStart,
          })),
        (CreatedAtEnd: Dayjs | null) =>
          setFilterState((prev) => ({ ...prev, CreatedAtEnd: CreatedAtEnd })),
      ]}
    >
      <ModalFieldOccurrences
        control={control}
        tableConfig={modalTableConfig}
        paginationConfig={historyPaginationConfig}
        modalConfig={modalConfig}
        setIsSearching={setIsSearching}
        user={user}
        isHistoryLoaded={isHistoryLoaded}
      />
    </SearchTable>,
  ];

  tabs.push("Ocorrências de Alerta SAN");
  panels.push(
    <OccurrenceAlertSan
      setIsSearching={setIsSearching}
      paginationConfig={paginationConfigOccurrenceAlertSan}
      setIdItem={setIdItem}
      tableConfig={tableConfigOccurrenceAlertSan}
      modalConfig={modalConfigOccurrenceAlertSan}
      reset={resetOccurrenceAlertSan}
      filterConfig={filterConfigOccurrenceAlertSan}
      setDates={[
        setOccurrenceAlertSanCreatedAtStart,
        setOccurrenceAlertSanCreatedAtEnd,
      ]}
      control={controlOccurrenceAlertSan}
    />,
  );

  return (
    <TabComponent
      tabs={tabs}
      panels={panels}
      headingElement={
        <>
          <Flex direction="row" justifyContent="space-between">
            <Heading as="h1">Ocorrências no Terreno</Heading>
            {user.permissions.includes("CreateOccurrences") && (
              <Button variant="secondary" onClick={handleAddNewItem}>
                Criar ocorrência
              </Button>
            )}
          </Flex>

          <Text>{FIELD_OCCURENCES_SUMMARY}</Text>
        </>
      }
    />
  );
};

export default FieldOccurrences;
